import React from 'react';
import { BusinessAutomationActionTypeEnum } from '@reach/shared-types/business-automation';
import styles from './WaitUntilDialog.module.css';

const { WAIT_UNTIL_NEXT_OCCURRENCE, WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME } =
  BusinessAutomationActionTypeEnum;

type WaitUntilActionType =
  | typeof WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME
  | typeof WAIT_UNTIL_NEXT_OCCURRENCE;

const { behaviorSelector } = styles;

interface BehaviorSelectorProps {
  value: WaitUntilActionType;
  onChange: (value: WaitUntilActionType) => void;
}

export const BehaviorSelector: React.FC<BehaviorSelectorProps> = ({
  value,
  onChange,
}) => {
  return (
    <fieldset className={behaviorSelector}>
      <legend>Behavior</legend>
      <p>
        Choose what happens if the target time has already passed for today.
      </p>
      <div>
        <label>
          <input
            type="radio"
            name="behavior"
            value={WAIT_UNTIL_NEXT_OCCURRENCE}
            checked={value === WAIT_UNTIL_NEXT_OCCURRENCE}
            onChange={() => onChange(WAIT_UNTIL_NEXT_OCCURRENCE)}
          />
          <div>
            <span>Wait Until Next Occurrence</span>
            <p>
              If the time has passed, wait until the same time tomorrow.
              Example: If target is 8:00 AM and it's currently 8:01 AM, wait
              until 8:00 AM tomorrow.
            </p>
          </div>
        </label>
        <label>
          <input
            type="radio"
            name="behavior"
            value={WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME}
            checked={value === WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME}
            onChange={() => onChange(WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME)}
          />
          <div>
            <span>Proceed If The Time Has Passed</span>
            <p>
              If the time has already passed today, proceed immediately without
              waiting. Example: If target is 8:00 AM and it's currently 8:01 AM,
              continue right away.
            </p>
          </div>
        </label>
      </div>
    </fieldset>
  );
};
